// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  changeStatusOrder,
  convertOrderToJob,
  deleteOrder,
  getListOrder,
  getListOrderEvent,
  getOrderDetail,
  getOrderSplit,
  sendMailOrder,
  splitOrder,
  updateOrder,
} from './orderThunk';

export interface IOrderState {
  isRefreshOrderList: boolean;
  isRefreshOrderEventList: boolean;
  isRefreshOrderDetail: boolean;
}

export const initialState: IOrderState = {
  isRefreshOrderList: false,
  isRefreshOrderEventList: false,
  isRefreshOrderDetail: false,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setRefreshOrderList: (state, action) => {
      state.isRefreshOrderList = action.payload;
    },
    setRefreshOrderEventList: (state, action) => {
      state.isRefreshOrderEventList = action.payload;
    },
    setRefreshOrderDetail: (state, action) => {
      state.isRefreshOrderDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get list order
    builder
      .addCase(getListOrder.pending, (_state) => {})
      .addCase(getListOrder.fulfilled, (_state) => {})
      .addCase(getListOrder.rejected, (_state) => {});
    // GET: Get list order event
    builder
      .addCase(getListOrderEvent.pending, (_state) => {})
      .addCase(getListOrderEvent.fulfilled, (_state) => {})
      .addCase(getListOrderEvent.rejected, (_state) => {});
    // POST: Convert order to job
    builder
      .addCase(convertOrderToJob.pending, (_state) => {})
      .addCase(convertOrderToJob.fulfilled, (_state) => {})
      .addCase(convertOrderToJob.rejected, (_state) => {});
    // GET: Get order detail
    builder
      .addCase(getOrderDetail.pending, (_state) => {})
      .addCase(getOrderDetail.fulfilled, (_state) => {})
      .addCase(getOrderDetail.rejected, (_state) => {});
    //POST: Split order
    builder
      .addCase(splitOrder.pending, (_state) => {})
      .addCase(splitOrder.fulfilled, (_state) => {})
      .addCase(splitOrder.rejected, (_state) => {});
    //DELETE: Delete order
    builder
      .addCase(deleteOrder.pending, (_state) => {})
      .addCase(deleteOrder.fulfilled, (_state) => {})
      .addCase(deleteOrder.rejected, (_state) => {});
    //PUT: Update order
    builder
      .addCase(updateOrder.pending, (_state) => {})
      .addCase(updateOrder.fulfilled, (_state) => {})
      .addCase(updateOrder.rejected, (_state) => {});

    // PUT: Send mail order
    builder
      .addCase(sendMailOrder.pending, () => {})
      .addCase(sendMailOrder.fulfilled, () => {})
      .addCase(sendMailOrder.rejected, () => {});

    // GET: Get order split
    builder
      .addCase(getOrderSplit.pending, () => {})
      .addCase(getOrderSplit.fulfilled, () => {})
      .addCase(getOrderSplit.rejected, () => {});

    //PUT: Change status order
    builder
      .addCase(changeStatusOrder.pending, (_state) => {})
      .addCase(changeStatusOrder.fulfilled, (_state) => {})
      .addCase(changeStatusOrder.rejected, (_state) => {});
  },
});

// Action
export const orderActions = orderSlice.actions;

// Selectors
export const selectIsRefreshOrderList = (state: RootState) => state.order.isRefreshOrderList;
export const selectIsRefreshOrderEventList = (state: RootState) => state.order.isRefreshOrderEventList;
export const selectIsRefreshOrderDetail = (state: RootState) => state.order.isRefreshOrderDetail;

// Reducer
const orderReducer = orderSlice.reducer;
export default orderReducer;
